import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import EditDateAutomationModal from 'modules/automations/components/EditDateAutomationModal'

const EditDateAutomationModalPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { id } = useStrictParams<'id'>()

  const onClose = () => {
    navigate(navigation.settings.automations.id.fullPath({ id }))
  }

  return <EditDateAutomationModal automationId={id} onClose={onClose} />
}

export default EditDateAutomationModalPage
